<svg
  *ngIf="iconContent"
  xmlns="http://www.w3.org/2000/svg"
  [attr.width]="size"
  [attr.height]="size"
  [attr.viewBox]="viewBox"
  [innerHTML]="iconContent">
</svg>